import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { PAGE } from '@ap-angular/shared/schema';
import { UserService } from '@ap-angular/service/user';
import { UserRoleEnumDTO } from '@auto-generated/ap-platform/users';

@Injectable()
export class IsLoggedGuard implements CanActivate {

	constructor(
		private userService: UserService,
		private router: Router
	) {
	}

	canActivate(): boolean {
		const IS_LOGGED_IN = this.userService.isLoggedIn();
		if (IS_LOGGED_IN) {
			const permissions: Array<string> = this.userService.getPermissions();
			switch (permissions[0]) {
				case UserRoleEnumDTO.INSTITUTIONMANAGER:
				case UserRoleEnumDTO.OFFICEMANAGER:
				case UserRoleEnumDTO.EMPLOYEE:
				case UserRoleEnumDTO.DEPARTMENTMANAGER:
				case UserRoleEnumDTO.ASSISTANT:
					this.router.navigate([PAGE.PROVIDER.path]).then();
					break;
				case UserRoleEnumDTO.SUPERADMIN:
				case UserRoleEnumDTO.ADMIN:
				case UserRoleEnumDTO.CUSTOMERCARE:
					this.router.navigate([PAGE.ADMIN.path]).then();
					break;
				case UserRoleEnumDTO.REFERENT:
					this.router.navigate([PAGE.PARTNER.path]).then();
					break;
				default:
					break;
			}
		}
		return !IS_LOGGED_IN;
	}
}
